import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import stylesGlobal from 'theme/facility-globals.scss';
import { section } from '../decorators';

const Blog = ({ children }) => {
  const [blogWidget, blogCategories] = React.Children.toArray(children);

  return (
    <div className={`${stylesGlobal.section} ${stylesGlobal.sectionNoPadBtm}`}>
      <Container>
        <Row>
          <Col lg={9} md={12} sm={12}>
            {blogWidget}
          </Col>
          <Col lg={3} md={6} sm={12}>
            {blogCategories}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Blog.propTypes = {
  children: PropTypes.node.isRequired,
};

const component = section(
  { name: 'Blog Page', category: 'Blog Page', deprecated: true },
  {
    subsections: [
      { accepts: ['BlogCategories'] },
      { accepts: ['BlogHome'] },
      { accepts: ['BlogPost'] },
    ],
    defaults: [
      'BlogHome',
      'BlogCategories',
    ],
    hideLabel: true,
    menu: false,
  },
)(Blog);

component.authorization = { requireHyper: true };

export default component;
